import { Guid } from '../../../model/guid';
import { getAllHotspotTabs, getHotspotTab } from '../trackingPersistenceMiddleware';
import { HotspotTab, Item, TrackingIdentifier } from '@ael/core-api';
import {
    createGetItemByIdFromItemsReducerState,
    createGetMaybeItemByIdFromItemsReducerState
} from '../selectors/getItemByIdFromItemsReducerState';
import {ItemsReducerState} from '../../../reducers/items/itemsReducer';

/* Return tracking identifier for given item id. */
export const convertItemIdToTrackingIdCreator =
  (getItems: () => ItemsReducerState) =>
  (itemId: Guid): TrackingIdentifier => {
    const items = getItems();
    const getItemByIdAllowUndefined = createGetMaybeItemByIdFromItemsReducerState(items);
    const getItemById = createGetItemByIdFromItemsReducerState(items);
    const item = getItemByIdAllowUndefined(itemId) || getHotspotTab(itemId, items, getItemById);
    if (item) {
      return item.trackingIdentifier;
    }

    throw Error(itemId + ' does not exist or it does not have tracking id, and this is invalid state.');
  };

/*
 * Returns item id for given tracking identifier.
 * Returns null if no item has given tracking id, e.g. item got deleted from the course
 * but its tracking id is still stored in external tracking storage.
 */
export const convertTrackingIdToItemIdCreator =
  (getItems: () => ItemsReducerState) =>
  (trackingId: TrackingIdentifier): Guid | null => {
    const items = getItems();
    const getItemById = createGetItemByIdFromItemsReducerState(items);
    const item =
      items.find((item: Item) => item.trackingIdentifier === trackingId) ||
      getAllHotspotTabs(items, getItemById).find((tab: HotspotTab) => tab.trackingIdentifier === trackingId);
    return item ? item.id : null;
  };
